export default __webpack_public_path__ + "static/media/develop.476bfa87.png";